import { useDappState } from '@src/hooks/useDappState';
import { DailyStreak } from './DailyStreak';
import {
  Button,
  HStack,
  Separator,
  Skeleton,
  Spinner,
  Text,
  VStack,
} from 'ui_2';
import { useClaimStreakReward, useStreaks } from '@src/hooks/useQuests';
import { DailyStatsData } from './DailyStatsData';

export const DailyStats = () => {
  const { isPro } = useDappState();

  const {
    data: streakData,
    isLoading: isLoadingStreaks,
    fetchStatus: streakFetchStatus,
    isError,
  } = useStreaks();

  const isActuallyLoadingStreaks =
    isLoadingStreaks && streakFetchStatus !== 'idle';

  const {
    claimStreakReward,
    isLoading: isLoadingClaim,
    isSuccess,
  } = useClaimStreakReward();

  if (isError) {
    return null;
  }

  const canClaim = streakData?.canClaimReward;

  return (
    <VStack className='w-full max-w-[500px] gap-3 rounded-[5px] bg-yellow-100 p-4 shadow-sm'>
      <Text font='bold-sm'>Today's stats</Text>
      <DailyStatsData />
      <Separator className='h-[1.5px] bg-gray-200' />
      <HStack className='w-full items-center justify-between'>
        {isActuallyLoadingStreaks && <Skeleton className='h-10 w-12' />}
        {!isActuallyLoadingStreaks && (
          <Text font='medium-lg'>🔥 {streakData?.currentStreak ?? 0}</Text>
        )}
        <VStack className='w-1/2'>
          <Text font='medium-xs'>Your streak</Text>
          <Text font='xs'>
            Do an activity on Puzzle everyday (game, giveaway, store purchase)
          </Text>
        </VStack>
      </HStack>
      {isActuallyLoadingStreaks && (
        <Skeleton className='h-[64px] w-full md:h-[72px]' delay={1} />
      )}
      {!isActuallyLoadingStreaks && (
        <DailyStreak
          streakData={
            streakData ?? {
              currentStreak: 0,
              milestones: [
                { daysRequired: 3, baseReward: 3, proBonus: 0 },
                { daysRequired: 7, baseReward: 8, proBonus: 0 },
                { daysRequired: 14, baseReward: 17, proBonus: 0 },
                { daysRequired: 30, baseReward: 40, proBonus: 0 },
                { daysRequired: 50, baseReward: 70, proBonus: 0 },
              ],
            }
          }
          isPro={isPro}
        />
      )}
      <HStack className='items-center justify-center gap-4'>
        <HStack className='w-1/2 justify-center'>
          {canClaim ? (
            <Button
              onClick={() => claimStreakReward()}
              size='md'
              className='items-center gap-2'
              disabled={isLoadingClaim || isSuccess}
            >
              <Text font='xs' color='white'>
                Claim Reward
              </Text>
              {isLoadingClaim && <Spinner />}
            </Button>
          ) : (
            <Button
              onClick={() => window.open('https://app.puzzle.online/games')}
              className='w-fit min-w-[120px]'
              size='md'
            >
              Play game
            </Button>
          )}
        </HStack>
      </HStack>
    </VStack>
  );
};
